import {
    DesignSystemBorderRadius,
    DesignSystemRadius,
    DesignSystemSize,
} from '../theme/design-system/types';
import { Theme } from '@mui/material/styles';

type RadiusInput<
    TSize extends string = DesignSystemSize,
    TRadius extends string = DesignSystemRadius,
> = {
    componentRadiusValues: Record<
        TSize,
        Record<TRadius, DesignSystemBorderRadius>
    >;
    radius: TRadius;
    size: TSize;
    theme: Theme;
};

export type RadiusOutput = {
    borderRadius: string;
};

export function getRadiusStyles<
    TSize extends string = DesignSystemSize,
    TRadius extends string = DesignSystemRadius,
>({
    componentRadiusValues,
    radius,
    size,
    theme,
}: RadiusInput<TSize, TRadius>): RadiusOutput {
    const semanticBorderRadiusKey = componentRadiusValues[size][radius];

    return {
        borderRadius: theme.borders.ds.borderRadius[semanticBorderRadiusKey],
    };
}
